import { render, staticRenderFns } from "./PluginBanner.vue?vue&type=template&id=66d30d8d&lang=html"
import script from "./PluginBanner.vue?vue&type=script&lang=js"
export * from "./PluginBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports